import React from "react";
import PropTypes from "prop-types";
import { Feed } from "semantic-ui-react";
import { styles } from "./element";
import Moment from "react-moment";

const QuesFeed = ({ date, data, name, head, username, userid, ...props }) => (
  <Feed style={styles.feed_item}>
    {userid ? (
      <Feed.Event>
        <Feed.Content>
          <Feed.Summary {...props} style={styles.color}>
            {head ? head : null} <span>{data} </span> <br />
            <span style={{ fontWeight: "200", fontSize: "14px" }}>
              Asked By{" "}
              <span style={{ textTransform: "capitalize", color: "#1b57a5" }}>
                <a
                  href={`/ProfileRealtor/?id=${userid}`}
                  target="_blank"
                  style={{ textTransform: "capitalize", color: "#1b57a5" }}
                >
                  <strong>{username}</strong>
                </a>
              </span>
              {/* <span style={{ textTransform: "capitalize" }}> {name}</span> */}
            </span>
            {date ? (
              <Feed.Date
                style={styles.date}
                content={<Moment fromNow>{date}</Moment>}
              />
            ) : null}
          </Feed.Summary>
        </Feed.Content>
      </Feed.Event>
    ) : (
      <Feed.Event>
        <Feed.Content>
          <Feed.Summary {...props} style={styles.color}>
            {head ? head : null} <span>{data} </span> <br />
            <span style={{ fontWeight: "200", fontSize: "14px" }}>
              Asked By{" "}
              <span style={{ textTransform: "capitalize" }}>
                <strong>{username}</strong>
              </span>
              {/* <span style={{ textTransform: "capitalize" }}> {name}</span> */}
            </span>
            {date ? (
              <Feed.Date
                style={styles.date}
                content={<Moment fromNow>{date}</Moment>}
              />
            ) : null}
          </Feed.Summary>
        </Feed.Content>
      </Feed.Event>
    )}
  </Feed>
);

QuesFeed.propTypes = {
  date: PropTypes.any,
  data: PropTypes.any,
};
export default QuesFeed;
